/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getRelatives } from 'app/entities/relatives/relatives.reducer';
import { createEntity, getEntity, reset, updateEntity } from './family-history.reducer';

export const FamilyHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const relatives = useAppSelector(state => state.relatives.entities);
  const familyHistoryEntity = useAppSelector(state => state.familyHistory.entity);
  const loading = useAppSelector(state => state.familyHistory.loading);
  const updating = useAppSelector(state => state.familyHistory.updating);
  const updateSuccess = useAppSelector(state => state.familyHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/family-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getRelatives({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...familyHistoryEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      relative: relatives.find(it => it.id.toString() === values.relative?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...familyHistoryEntity,
          patient: familyHistoryEntity?.patient?.id,
          relative: familyHistoryEntity?.relative?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.familyHistory.home.createOrEditLabel" data-cy="FamilyHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.familyHistory.home.createOrEditLabel">Create or edit a FamilyHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="family-history-id"
                  label={translate('tinyMedicRestApp.familyHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.relationShip')}
                id="family-history-relationShip"
                name="relationShip"
                data-cy="relationShip"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.currAge')}
                id="family-history-currAge"
                name="currAge"
                data-cy="currAge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.ageOfDeath')}
                id="family-history-ageOfDeath"
                name="ageOfDeath"
                data-cy="ageOfDeath"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.medicalProblems')}
                id="family-history-medicalProblems"
                name="medicalProblems"
                data-cy="medicalProblems"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.active')}
                id="family-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.draft')}
                id="family-history-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.cursor')}
                id="family-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.lastUpdated')}
                id="family-history-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.microSec')}
                id="family-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.familyHistory.timestampEntry')}
                id="family-history-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="family-history-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.familyHistory.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="family-history-relative"
                name="relative"
                data-cy="relative"
                label={translate('tinyMedicRestApp.familyHistory.relative')}
                type="select"
              >
                <option value="" key="0" />
                {relatives
                  ? relatives.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/family-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FamilyHistoryUpdate;
